import React, { ReactNode, useContext, useEffect, useState } from 'react'
import PublicNavbar from '../components/PublicNavbar/PublicNavbar'
import * as styles from './Layouts.styles'
import layoutStyles from './Layouts.module.scss'
import CTA from '../assets/newAuthImage.png'
import bottomLines from '../assets/forgotPasswordLines.png'
import { useNavigate } from 'react-router-dom'
import { UserContext } from '../contexts/UserContext'


interface PublicLayoutProps {
  children: ReactNode;
}
const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const navigate = useNavigate()
  const {userDetails, setUserDetails,fetchUser}= useContext(UserContext) ?? {}
  useEffect(()=>{
    let token= sessionStorage.getItem("accessToken")
    
    // if (fetchUser) {
    //   fetchUser()
    // }
    if(token) navigate('/overview')
    // else navigate('/login')
  },[navigate])
  return (
    <div className={styles.layoutWrapper}>
      <PublicNavbar />
      <div className='grid sm:grid-cols-1 md:grid-cols-2 min-h-[100vh] pt-[4rem]'>
        <div className={styles.imgContainer}>
          <img src={CTA} className={styles.img} />
        </div>
        {children}
      </div>
      <div className={styles.publicLayoutFooter}>
        {/* <img src={bottomLines} className='w-full' /> */}
      </div>
    </div>
  )
}

export default PublicLayout
